import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import { Box, Button, Tabs, Tab, Paper, Typography, Grid, Card, CardContent, Divider, FormControl } from "@mui/material";
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import ClearIcon from '@mui/icons-material/Clear';

const GstModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    maxWidth: "500px",
    height: "auto",
    maxHeight: "90vh",
    bgcolor: "white !important",
    border: "1px solid #fff",
    borderRadius: "10px",
    boxShadow: 30,
    p: 4,
    overflowY: "auto",
    "@media (max-width: 600px)": {
        width: "90%",
        maxHeight: "100vh",
        height: '500px',
    },
};

const GstDetailsModal = ({ isGstModal, closePopup, onGstDetails, isEditGstData }) => {
    const [gstNo, setGstNo] = useState('')
    const [billTo, setBillTo] = useState('')
    const [flatNo, setFlatNo] = useState('')
    const [address, setAddress] = useState('')
    const [selectState, setSelectState] = useState('')
    const [gstNoError, setGstNoError] = useState('')
    const [billToError, setBillToError] = useState('')
    const [flatNoError, setFlatNoError] = useState('')
    const [addressError, setAddressError] = useState('')
    const [selectStateError, setSelectStateError] = useState('')
    const [gstDetails, setGstDetails] = useState([])
    const [tanNo, setTanNo] = useState('')
    const [tanNoError, setTanNoError] = useState('')
    const indianStates = [
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chhattisgarh",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal"
    ];
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (isGstModal) {
            if (isEditGstData) {
                setGstNo(isEditGstData[0]?.gstNo);
                setAddress(isEditGstData[0]?.address);
                setBillTo(isEditGstData[0]?.billTo);
                setFlatNo(isEditGstData[0]?.flatNo);
                setSelectState(isEditGstData[0]?.selectState);
                setTanNo(isEditGstData[0]?.tanNo);
            }
            setOpen(true)
        } else {
            setOpen(false)
        }
    }, [isGstModal])


    const handleClose = () => {
        closePopup(false);
        setOpen(false);
        handleClearForm()
    };

    const handleChangeGstNo = (event) => {
        const value = event.target.value.toUpperCase();
        const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        if (!gstRegex.test(value)) {
            setGstNoError('Please provid a valid GSTN (e.g. 09ABCDE1234F2Z5)')
        } else {
            setGstNoError('')
        }
        setGstNo(value)
    }
    const handleChangeTanNo = (event) => {
        const value = event.target.value.toUpperCase(); 
        const tanRegex = /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/;

        if (!tanRegex.test(value)) {
            setTanNoError('Please provide a valid TAN (e.g., ABCD99999A)');
        } else {
            setTanNoError('');
        }

        setTanNo(value);
    }
    const handleChangeBillTo = (event) => {
        const value = event.target.value
        if (!value) {
            setBillToError('Please provid a valid information')
        } else {
            setBillToError('')
        }
        setBillTo(value)
    }
    const handleChangeFlatNo = (event) => {
        const value = event.target.value
        if (!value) {
            setFlatNoError('Please provid a valid information')
        } else {
            setFlatNoError('')
        }
        setFlatNo(value)
    }
    const handleChangeAddress = (event) => {
        const value = event.target.value
        if (!value) {
            setAddressError('Please provid a valid information')
        } else {
            setAddressError('')
        }
        setAddress(value)
    }
    const handleChangeSelectState = (event) => {
        const value = event.target.value
        if (!value) {
            setSelectStateError('Please provid a valid information')
        } else {
            setSelectStateError('')
        }
        setSelectState(value)
    }
    const handleClearForm = () => {
        setGstNo('')
        setGstNoError('')
        setBillTo('')
        setBillToError('')
        setFlatNo('')
        setFlatNoError('')
        setAddress('')
        setAddressError('')
        setSelectState('')
        setSelectStateError('')
    }

    const handleChangeSubmit = (event) => {
        event.preventDefault();
        let isValid = true;
        if (!gstNo) {
            setGstNoError('Please provid a valid information')
            isValid = false;
        }

        if (!billTo) {
            setBillToError('Please provid a valid information')
            isValid = false;
        }

        if (!flatNo) {
            setFlatNoError('Please provid a valid information')
            isValid = false;
        }

        if (!address) {
            setAddressError('Please provid a valid information')
            isValid = false;
        }

        if (!selectState) {
            setSelectStateError('Please provid a valid information')
            isValid = false;
        }
        if (!isValid) {
            return;
        }
        const requestBody = [{
            gstNo: gstNo,
            billTo: billTo,
            flatNo: flatNo,
            address: address,
            selectState: selectState,
            tanNo: tanNo
        }]
        onGstDetails(requestBody);
        handleClearForm()
        handleClose()
        closePopup(true)
    }
    const handleUpdateGst = (event) => {
        event.preventDefault();
        let isValid = true;
        if (!gstNo) {
            setGstNoError('Please provid a valid information')
            isValid = false;
        }

        if (!billTo) {
            setBillToError('Please provid a valid information')
            isValid = false;
        }

        if (!flatNo) {
            setFlatNoError('Please provid a valid information')
            isValid = false;
        }

        if (!address) {
            setAddressError('Please provid a valid information')
            isValid = false;
        }

        if (!selectState) {
            setSelectStateError('Please provid a valid information')
            isValid = false;
        }
        if (!isValid) {
            return;
        }
        const requestBody = [{
            gstNo: gstNo,
            billTo: billTo,
            flatNo: flatNo,
            address: address,
            selectState: selectState,
            tanNo: tanNo
        }]
        onGstDetails(requestBody);
        handleClearForm()
        handleClose()
        closePopup(true)
    }
    return (
        <div>
            <Modal className='gst-modal' open={open} aria-labelledby="modal-modal-title">
                <Box sx={GstModalStyle}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Typography id="modal-modal-title" variant="h6">
                            <strong>GST Details</strong>
                        </Typography>
                        <Button variant="text" color="inherit" onClick={handleClose}>
                            <ClearIcon />
                        </Button>
                    </Box>
                    <Divider className="mt-2"></Divider>
                    <Card style={{ backgroundColor: 'lightblue', marginTop: '10px', padding: '5px' }}>
                        Please note: Kindly make sure you enter the correct details as they can’t be changed once saved. Once your booking has been confirmed, we cannot modify GST/TAN details.
                    </Card>
                    <form className='gst-form'>
                        <div className='gst-form-container'>
                            <Grid container spacing={2} className='gst-form' sx={{ marginTop: '8px' }}>
                                <Grid item xs={12} sm={12} md={12}>
                                    <TextField fullWidth label="GSTIN" variant="outlined" value={gstNo} inputProps={{ maxLength: 15 }} onChange={handleChangeGstNo} />
                                    {gstNoError && <p style={{ color: "red", margin: "2px" }}>{gstNoError}</p>}
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <TextField fullWidth label="Bill To" variant="outlined" value={billTo} onChange={handleChangeBillTo} />
                                    {billToError && <p style={{ color: "red", margin: "2px" }}>{billToError}</p>}
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <TextField fullWidth label="Flat No./Building" variant="outlined" value={flatNo} onChange={handleChangeFlatNo} />
                                    {flatNoError && <p style={{ color: "red", margin: "2px" }}>{flatNoError}</p>}
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <TextField fullWidth label="Address" variant="outlined" value={address} onChange={handleChangeAddress} />
                                    {addressError && <p style={{ color: "red", margin: "2px" }}>{addressError}</p>}
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <FormControl sx={{ width: '100%' }}>
                                        <InputLabel id="demo-simple-select-label">State</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={selectState}
                                            label="State"
                                            onChange={handleChangeSelectState}
                                            fullWidth
                                        >
                                            {indianStates.map((city) => (
                                                <MenuItem key={city} value={city}>
                                                    {city}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    {selectStateError && <p style={{ color: 'red' }}>{selectStateError}</p>}
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <TextField fullWidth label="TAN" variant="outlined" value={tanNo} inputProps={{maxLength:10}} onChange={handleChangeTanNo} />
                                    {tanNoError && <p style={{ color: "red", margin: "2px" }}>{tanNoError}</p>}
                                </Grid>

                                <Grid item xs={12} md={12}>
                                    <Button className='mb-2' fullWidth type="submit" variant="contained" color="primary" style={{ backgroundColor: '#fff099', color: '#2d2b29', height: '48px' }} onClick={isEditGstData ? handleUpdateGst : handleChangeSubmit}>
                                        {isEditGstData ? 'Add GST Details' : 'Edit GST Details'}
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>
                    </form>
                </Box>
            </Modal>
        </div>
    )
}

export default GstDetailsModal
